import React from "react";
import { Mail } from "lucide-react";

const EMAIL = "team@altezamarketplace.com";

const REASONS = [
  { title: "General inquiries", desc: "Questions about Alteza, our makers or how the marketplace works." },
  { title: "Partnerships", desc: "Collaborations, press, wholesale and brand partnerships." },
  { title: "Seller support", desc: "Help with your shop, listings, shipping, payouts or onboarding." },
  { title: "Customer support", desc: "Questions about an order, a return or something you purchased." },
];

export default function Contact() {
  return (
    <div data-testid="contact-page" className="max-w-3xl mx-auto px-6 py-24 lg:py-32">
      <div className="text-xs tracking-[0.3em] uppercase text-muted-foreground mb-4">◦ Get in touch</div>
      <h1 className="font-serif text-5xl lg:text-6xl tracking-tight font-light">Contact.</h1>
      <p className="mt-6 text-muted-foreground leading-relaxed max-w-xl">
        We'd love to hear from you. Whether you're a shopper, a maker or a potential partner,
        reach us any time at the address below and we'll get back to you.
      </p>

      <a
        data-testid="contact-email-link"
        href={`mailto:${EMAIL}`}
        className="mt-10 inline-flex items-center gap-3 border border-border rounded-sm px-5 py-4 hover:border-primary hover:text-primary transition-colors"
      >
        <Mail className="w-5 h-5" />
        <span className="text-base tracking-wide">{EMAIL}</span>
      </a>

      <div className="mt-14 grid grid-cols-1 sm:grid-cols-2 gap-x-12 gap-y-10">
        {REASONS.map((r) => (
          <div key={r.title} data-testid={`contact-reason-${r.title.toLowerCase().replace(/\s+/g, "-")}`}>
            <h2 className="font-serif text-xl mb-2">{r.title}</h2>
            <p className="text-sm text-muted-foreground leading-relaxed">{r.desc}</p>
            <a href={`mailto:${EMAIL}`} className="mt-3 inline-block text-sm text-primary hover:underline">
              {EMAIL}
            </a>
          </div>
        ))}
      </div>
    </div>
  );
}
